import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-surface-guarantee py-10 px-6" data-id="element-156">
      <div className="max-w-3xl mx-auto text-center" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-158">
          <div className="flex justify-center mb-4" data-id="element-159">
            <ShieldCheck className="w-16 h-16 text-success" data-id="element-160" />
          </div>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-primary mb-4" data-id="element-161">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <div className="space-y-2 text-lg text-primary font-medium mb-6" data-id="element-162">
            <p data-id="element-163">Abres los tomos. Los aplicas en casa.</p>
            <p data-id="element-164">Si en 7 días no es exactamente lo que esperabas:</p>
            <p className="text-2xl font-bold text-success my-3" data-id="element-165">
              Devolución del 100% de tu dinero.
            </p>
            <p data-id="element-166">Sin formularios. Sin drama. Sin explicaciones.</p>
          </div>

          <div className="bg-white/60 rounded-xl p-4 inline-block" data-id="element-167">
            <p className="font-bold text-primary" data-id="element-168">
              Tasa de devoluciones: menos del 1%.
            </p>
            <p className="text-secondary mt-1" data-id="element-169">
              Porque sabemos lo que tienes entre manos.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}